export class Constants {
    public static readonly In_Compliance = 1;
    public static readonly  Not_Applicable = 2;
    public static readonly Out_of_Compliance = 3;
    public static readonly Unobserved = 4;
  }

  export class InspectionStatus {
    public static readonly Incomplete = 1;
    public static readonly  Complete = 2;
    public static readonly NeedsReview = 3;
  }